/** Server: runtime `OPS_SIGNAL_URL`. Browser: build-time `NEXT_PUBLIC_OPS_SIGNAL_ENABLED` (from next.config). */
export function isOpsSignalEnabled(): boolean {
  if (typeof window === 'undefined') {
    return Boolean((process.env.OPS_SIGNAL_URL || '').trim());
  }
  const flag = process.env.NEXT_PUBLIC_OPS_SIGNAL_ENABLED || '';
  return flag === '1' || flag === 'true';
}
